export default function getSessionEnd(session) {
	if (session.end && session.finish && session.status === "done") {
		if (typeof session.finish === "string") {
			const [hours, minutes] = session.finish.split(":").map(Number);

			const endDate = new Date(session.end.toDate());

			endDate.setHours(hours, minutes, 0, 0);

			return endDate;
		} else {
			return session.finish.toDate();
		}
	}

	return session.end?.toDate();
}
